import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import SubtitleFields from './formGroupVodEncodingSubtitleSettings';
import AudioVariantsFields from './formGroupVodEncodingAudioVariantsSettings';

export default {

  title: 'Encoding Settings',
  attributeName: 'encodingSettingsFormGroup',
  validationUrl: 'vod',
  fields: [
    {
      attributeName: 'isEncrypt',
      type: FormInputTypes.CHECKBOX,
      label: 'Encrypted',
      helpText: 'Checked if you want to encrypt the video output.',
      default: false,
      errorText: '',
    },
    {
      attributeName: "drm_provider",
      type: FormInputTypes.SELECT,
      label: "DRM provider",
      multiple: false,
      options: [
        { name: 'Clear key', value:'clearkey' },
        { name: 'Axinom', value:'axinom' }
      ],
      helpText: "Provide drm provider",
      visibleWhen: [{ field: "isEncrypt", value: true }],

    },
    {
      attributeName: 'videoCodec',
      type: FormInputTypes.SELECT,
      label: 'Video Codec',
      helpText: 'Video codec to use for processing; libx265 and libx264 are the accepted values.',
      required: true,
      default:'hevc_nvenc',
      options: [
        { name: 'hevc_nvenc', value:'hevc_nvenc' },
        { name: 'h264_nvenc', value: 'h264_nvenc' },
        { name: 'libx265', value: 'libx265' },
        { name: 'libx264', value: 'libx264' },
        { name: 'av1_nvenc', value: 'av1_nvenc' },
        { name: 'libsvtav1', value: 'libsvtav1' }
      ],
    },
    {
      attributeName: 'segmentLength',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Segment length number in milliseconds...',
      label: 'Segment Length (ms)',
      required: true,
      helpText: 'Segment length in the output, it is in milliseconds format.',
      errorText: '',
      default: 500,
      pattern: /^[0-9\b]+$/,
    },
    {
      attributeName: 'isDiffStereo',
      type: FormInputTypes.CHECKBOX,
      label: 'Differential stereo',
      required: true,
      helpText: 'Differential stereo is to apply YBVR differential stereo encoding feature.',
      errorText: '',
    },
    {
      attributeName: 'audioCodec',
      type: FormInputTypes.SELECT,
      helpText: 'The audio codec to apply in all the job.',
      label: 'Audio Codec',
      required: true,
      default:'libfdk_aac',
      options: [
        { name: 'AAC', value: 'libfdk_aac' },
      ],
    },
    {
      attributeName: 'audioBitrate',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Audio bitrate in kbps...',
      label: 'Audio bitrate (kbps)',
      required: true,
      helpText: 'The audio bitrate to apply in kbps.',
      pattern: /^[0-9\b]+$/,
      default: 128,
      errorText: '',
    },
    {
      attributeName: 'quality_level',
      type: FormInputTypes.SELECT,
      helpText: 'The quality level to apply in all the job.',
      label: 'Quality Level',
      required: true,      
      default:'standard',
      options: [
        { name: 'STANDARD', value: 'standard' },
        { name: 'HIGH', value: 'high' },
        { name: 'FAST', value: 'fast' },
      ],
    },
      {
      attributeName: 'audio_variants',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any audio variants yet.",
      itemLabel:'AudioVariants',
      columns:2,
      label: 'Audio Variants',
      required: true,
      helpText: 'Insert new audio variants.',
      errorText: '',
      classCss:"jsonComponent__width100",
      popupFormGroups:[
        AudioVariantsFields
      ]
    },
    {
      attributeName: 'subtitle_variants',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any subtitles yet.",
      itemLabel:'Subtitles',
      columns:2,
      label: 'Subtitles',
      required: true,
      helpText: 'Insert new subtitles.',
      errorText: '',
      classCss:"jsonComponent__width100",
      popupFormGroups:[
        SubtitleFields
      ]
    },
  ],
};
